/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chip, Typography, useMediaQuery } from "@mui/material";
import MainTable from "../Components/GenericComponents/MainTable";
import { StatusModel } from "../Utils/Models";
import styles from "../Styles/dashboard.module.css";
import { useState } from "react";
import { urlEnum } from "../Utils/UrlEnum";
import { Vocabulary } from "../Utils/Vocabulary";
import { formatStringDate } from "../Utils/Utils";
import Config from "../Utils/Config";
import { Visibility } from "@mui/icons-material";
import GenericModal from "../Components/GenericComponents/GenericModal";
import Log from "../Components/GenericComponents/Log";

const Audits = () => {
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [open, setOpen] = useState(false);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [selectedLog, setSelectedLog] = useState<any>({});

  //TO DO add the labels to the vocabulary
  const statusHeader = [
    {
      label: Vocabulary.userName,
      name: "userName",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.method,
      name: "method",
      options: {
        sort: false,
        customBodyRender: (method: any) => (
          <Typography>{Vocabulary[method]}</Typography>
        ),
      },
    },
    {
      label: Vocabulary.table,
      name: "table",
      options: {
        sort: false,
        customBodyRender: (table: string) => (
          <Typography>{Vocabulary[table]}</Typography>
        ),
      },
    },
    {
      label: Vocabulary.entityName,
      name: "identifier",
      options: {
        sort: false,
        customBodyRender: (name: any) => <Typography>{name || "-"}</Typography>,
      },
    },
    {
      label: Vocabulary.status,
      name: "status",
      options: {
        sort: false,
        customBodyRender: (status: any) => (
          <Chip
            className={styles[status]}
            label={<Typography>{Vocabulary[status]}</Typography>}
          />
        ),
      },
    },
    {
      label: Vocabulary.date,
      name: "createdAt",
      options: {
        sort: false,
        customBodyRender: (date: any) => (
          <Typography>
            {formatStringDate(date, Config.datePickerFormat)}
          </Typography>
        ),
      },
    },
  ];

  function handleEdit(item: StatusModel | null) {
    setShouldUpdate(false);
    setOpen(!open);
  }

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <MainTable
        urlEnumApi={urlEnum.audit}
        header={statusHeader}
        tableTitle={Vocabulary.auditsList}
        shouldUpdate={shouldUpdate}
        handleEdit={handleEdit}
        hideOptionButtons={{
          add: true,
          edit: {
            condition: (item: any) => true,
          },
          delete: {
            condition: (item: any) => true,
          },
        }}
        anotherOptionButtons={[
          {
            condition: (item: any) => true,
            icon: <Visibility />,
            title: Vocabulary.preview, //To add to vocabulary
            action: (item: any) => {
              setOpenView(true);
              setSelectedLog(item);
            },
          },
        ]}
      />
      <GenericModal
        open={openView}
        onClose={() => {
          setOpenView(false);
        }}
        title={Vocabulary.auditDetails}
        styleDialogPaper={{
          width: "100%",
          maxWidth: "900px",
          height: "60vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Log log={selectedLog} />
      </GenericModal>
    </div>
  );
};

export default Audits;
